// import { Config } from "../../../core/config/config";
// import "facebook-js-sdk";
import { InstagramService } from "./instagramService";
// let accessToken = "";
export class BrowserInstagramService implements InstagramService {
	constructor() {
		// // The FB SDK requires a 'window.fbAsyncInit' method to load.
		// // eslint-disable-next-line @typescript-eslint/no-explicit-any
		// (window as any).fbAsyncInit = function () {
		// 	FB.init({
		// 		appId: Config.FACEBOOK_APP_ID,
		// 		cookie: true,
		// 		xfbml: true,
		// 		version: "v8.0",
		// 	});
		// 	FB.getLoginStatus((response) => {
		// 		accessToken = response.authResponse?.accessToken;
		// 		// console.log("access token", response.authResponse?.accessToken);
		// 	});
		// };
		// (function (d, s, id) {
		// 	const fjs = d.getElementsByTagName(s)[0];
		// 	if (d.getElementById(id)) {
		// 		return;
		// 	}
		// 	const js = d.createElement(s) as HTMLScriptElement;
		// 	js.id = id;
		// 	js.src = "https://connect.facebook.net/en_US/sdk.js";
		// 	if (fjs.parentNode !== null) {
		// 		fjs.parentNode.insertBefore(js, fjs);
		// 	}
		// })(document, "script", "facebook-jssdk");
	}
	// getFacebookPages = (): Promise<any> => {
	// 	return new Promise((resolve) => {
	// 		window.FB.api("me/accounts", { access_token: accessToken }, (response: any) => {
	// 			resolve(response?.data);
	// 		});
	// 	});
	// };

	// getInstagramAccountId = (facebookPageId: any): Promise<any> => {
	// 	return new Promise((resolve) => {
	// 		window.FB.api(
	// 			facebookPageId,
	// 			{
	// 				access_token: accessToken,
	// 				fields: "instagram_business_account",
	// 			},
	// 			(response: any) => {
	// 				resolve(response?.instagram_business_account?.id);
	// 			}
	// 		);
	// 	});
	// };

	// createMediaObjectContainer = (instagramAccountId: any): Promise<any> => {
	// 	return new Promise((resolve) => {
	// 		window.FB.api(
	// 			`${instagramAccountId}/media`,
	// 			"post",
	// 			{
	// 				access_token: accessToken,
	// 				image_url: "https://cdn.app-dev.tooshare.com/assets/26ba269a2efd4a56a311c792b74fc701.png",
	// 				caption: "test instagram",
	// 			},
	// 			(response: any) => {
	// 				resolve(response?.id);
	// 			}
	// 		);
	// 	});
	// };

	// publishMediaObjectContainer = (instagramAccountId: any, mediaObjectContainerId: any): Promise<any> => {
	// 	return new Promise((resolve) => {
	// 		window.FB.api(
	// 			`${instagramAccountId}/media_publish`,
	// 			"post",
	// 			{
	// 				access_token: accessToken,
	// 				creation_id: mediaObjectContainerId,
	// 			},
	// 			(response: any) => {
	// 				resolve(response?.id);
	// 			}
	// 		);
	// 	});
	// };

	// authenticateInstagram = (): Promise<any> => {
	// 	return new Promise((resolve) => {
	// 		FB.login(
	// 			(response) => {
	// 				if (response.authResponse) {
	// 					accessToken = response.authResponse.accessToken;
	// 					resolve(response.authResponse);
	// 				} else {
	// 					console.error("User cancelled login or did not fully authorize.");
	// 				}
	// 			},
	// 			{ scope: "instagram_basic" }
	// 		);
	// 	});
	// };

	// async openShareDialog(url: string, text: string): Promise<void> {
	// await this.authenticateInstagram();
	// 	const facebookPages = await this.getFacebookPages();
	// 	const instagramAccountId = await this.getInstagramAccountId(facebookPages[0].id);
	// 	const mediaObjectContainerId = await this.createMediaObjectContainer(instagramAccountId);

	// 	await this.publishMediaObjectContainer(instagramAccountId, mediaObjectContainerId);
	// }

	async openShareDialog(): Promise<void> {
		return;
	}
}
